/*
 * Copyright © 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschützt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulässig. Dies gilt
 * insbesondere für Vervielfältigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht übergeben, ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 */
import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import {RouterHelper} from '../../../dvbModules/router/route-helper-provider';
import {TSSchadenfallStatus} from '../../../models/enums/TSSchadenfallStatus';
import {PageNameConstants} from '../../service/PageNameConstants';
import RoleUtilService from '../../service/RoleUtilService';
import SchadenfallModelManager from '../../service/SchadenfallModelManager';

require('./dv-gesuch-navigation.scss');
let template = require('./dv-gesuch-navigation.html');

export class DvGesuchNavigationComponentConfig implements IComponentOptions {
    transclude = true;
    bindings: any = {
        schadenfallId: '@',
        title: '@?',
        status: '@',
        herkunft: '@',
        sticky: '<',
    };
    template = template;
    controller = DvGesuchNavigationController;
    controllerAs = 'vm';
}

export class DvGesuchNavigationController {
    static $inject: string[] = ['$state', 'RouterHelper', 'RoleUtilService', 'SchadenfallModelManager', 'PAGE_NAMES'];
    schadenfallId: string;
    status: TSSchadenfallStatus;
    sticky: boolean;

    constructor(private $state: IStateService, private routerHelper: RouterHelper, private roleUtilService: RoleUtilService,
                private schadenfallModelManager: SchadenfallModelManager, private pageNames: PageNameConstants,
    ) {
    }

    $onInit() {

    }

    public showEntschaedigung(): boolean {
        return this.schadenfallModelManager.isSchadenVisible(this.pageNames.ENTSCHAEDIGUNG);
    }

    public showAufwaende(): boolean {
        return this.schadenfallModelManager.isSchadenVisible(this.pageNames.AUFWAENDE);
    }

    public showSchaetzung(): boolean {
        return this.schadenfallModelManager.isSchadenVisible(this.pageNames.SCHAETZUNG);
    }

    public showBemerkung(): boolean {
        return this.schadenfallModelManager.isSchadenVisibleAndNotNew(this.pageNames.BEMERKUNG);
    }

}



// WEBPACK FOOTER //
// ./src/app/core/component/dv-gesuch-navigation/dv-gesuch-navigation.ts